import { i as f } from "../separate-component-helper-chunks/reactive-element-BDpydG15.js";
import { html as c, nothing as u } from "../beacon-html.d/index.js";
import "../separate-component-helper-chunks/lit-element-DC8UPTKS.js";
import { property as g } from "../beacon-property.d/index.js";
import { html as v } from "../beacon-static-html.d/index.js";
import { B as k } from "../separate-component-helper-chunks/form-base-6uTDnSZ3.js";
import { a as y, b as B } from "../separate-component-helper-chunks/helper-DZFulwV_.js";
import { B as C } from "../separate-component-helper-chunks/beacon-primitive-ChVMWFlW.js";
import { p as O } from "../separate-component-helper-chunks/lifecycle-decorators-CUsT9aHq.js";
import { c as x } from "../separate-component-helper-chunks/query-assigned-DZ4JAxBy.js";
const F = f`[beacon-tag-name=beacon-radio-group] [beacon-tag-name=beacon-radio-button]{margin-block:10px}[beacon-tag-name=beacon-radio-group] [beacon-tag-name=beacon-radio-button]:last-of-type{margin-block-end:0}`, $ = f`label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}fieldset{border:0;padding:0}.radio-buttons{align-items:var(--beacon-custom-radio-group-radio-buttons-align-items, initial);display:var(--beacon-custom-radio-group-radio-buttons-display, flex);flex-direction:var(--beacon-custom-radio-group-radio-buttons-flex-direction, column);gap:var(--beacon-custom-radio-group-radio-buttons-gap, 0);justify-content:var(--beacon-custom-radio-group-radio-buttons-justify-content, initial)}::slotted([beacon-tag-name=beacon-radio-button]){margin-block:10px}::slotted([beacon-tag-name=beacon-radio-button]:last-of-type){margin-block-end:0}`;
var I = Object.defineProperty, R = Object.getOwnPropertyDescriptor, d = (h, t, e, a) => {
  for (var i = a > 1 ? void 0 : a ? R(t, e) : t, o = h.length - 1, s; o >= 0; o--)
    (s = h[o]) && (i = (a ? s(t, e, i) : s(i)) || i);
  return a && i && I(t, e, i), i;
};
const p = "beacon-radio-group", V = ["beacon-error"], r = class r extends C(k) {
  constructor() {
    super(...arguments), this.beaconTagName = p, this.name = "radio", this.reflectPropertiesOnAssigned = (t, e) => {
      e.forEach((a) => {
        t.forEach((i) => {
          i in a && (a[i] = this[i]);
        });
      });
    }, this.updateBooleanProps = () => {
      this.radioButtons && (this.reflectInvalidOnAssigned(), this.reflectDisabledOnAssigned());
    }, this.updateValueFromChecked = () => {
      this.radioButtons && this.radioButtons.forEach((t) => {
        var e;
        t.checked && (this.value = t.value, (e = this.internals) == null || e.setFormValue(this.value));
      });
    }, this.validateRadioGroup = (t) => {
      if (this.required && !this.value && !this.validateOneChecked(t) && !this.disabled) {
        const e = this.errorsMap.required || this.defaultMessages.required;
        this.setValidity({ valueMissing: !0 }, e, this.radioGroupFormAnchor), this.requestUpdate("invalid");
      } else
        this.setValidity({ valueMissing: !1 }, void 0, this.radioGroupFormAnchor), this.requestUpdate("invalid");
    }, this.validateOneChecked = (t) => {
      let e = 0;
      return t.forEach((a) => {
        a.checked && (e += 1);
      }), e === 1;
    }, this.requiredValidation = () => {
      this.radioButtons && this.validateRadioGroup(this.radioButtons);
    }, this.handleRadioGroupFocus = (t) => {
      this.emitFocus(t);
    }, this.handleRadioGroupInput = (t) => {
      this.updatePreventDisabled(t), this.emitInput(t);
    }, this.handleRadioGroupClick = (t) => {
      this.updatePreventDisabled(t), this.emitClick(t);
    }, this.handleRadioGroupChange = (t) => {
      this.updatePreventDisabled(t), this.emitChange(t);
    }, this.updateValidity = () => {
      this.invalid && this.requiredValidation();
    }, this.uncheckOtherButtons = (t) => {
      const e = t.target;
      e.checked = !0, this.radioButtons && this.radioButtons.forEach((a) => {
        a.label !== e.label && (a.checked = !1, a.focusable = !1);
      });
    }, this.handleSlotChange = () => {
      this.radioButtons && this.updateRadioButtonInternalValue();
    }, this.updateRadioButtonInternalValue = () => {
      this.radioButtons.forEach((t) => {
        var e;
        (e = t.internals) == null || e.setFormValue("");
      });
    }, this.getCheckedRadioIndex = (t) => {
      var a;
      const e = (a = t.find((i) => i.checked)) != null ? a : t[0];
      return t.indexOf(e);
    }, this.checkOnlyLast = () => {
      if (this.radioButtons) {
        const t = this.radioButtons.filter((i) => i.checked), e = this.radioButtons.map((i) => i.checked === !0).lastIndexOf(!0), a = this.radioButtons[e];
        t.forEach((i) => {
          i.checked = !1;
        }), a && (a.checked = !0);
      }
    }, this.setFocusableOnEmpty = () => {
      this.radioButtons.some((e) => e.checked) || (this.radioButtons[0].focusable = !0);
    }, this.focusFromKey = (t, e) => {
      const { key: a } = t, i = y(a);
      if (i !== 0) {
        const o = e.filter((m) => !m.disabled), s = o.length, b = this.getCheckedRadioIndex(o), l = B(b, i, s);
        o[l].focusShadow(), o[l].radioButton.click(), this.emitInput();
      }
    };
  }
  static get styles() {
    return [super.styles, $];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, F];
  }
  /** The anchor for element internals within the group of radio buttons. */
  get radioGroupFormAnchor() {
    return this.radioButtons[0].formAnchor;
  }
  /**
   * Reflects the `invalid` state onto slotted radio-buttons
   */
  reflectInvalidOnAssigned() {
    this.radioButtons && this.reflectPropertiesOnAssigned(["invalid"], this.radioButtons);
  }
  /**
   * Conditionally applies disabled to all slotted radio buttons
   * only when disabled is explicitly set on the group to prevent overriding
   * consumer disabling specifc radio button items.
   */
  reflectDisabledOnAssigned() {
    this.disabled && this.radioButtons && this.reflectPropertiesOnAssigned(["disabled"], this.radioButtons);
  }
  /**
   * Sets the form and internal value to the captured event target value
   * then unchecks other radio-buttons and resets validity checking
   * @param event
   */
  captureEventValue(t) {
    this.internals && (this.value = t.target.value, this.internals.setFormValue(this.value)), this.uncheckOtherButtons(t), this.updateValidity();
  }
  /**
   * Emits a beacon-event-keydown then attempts to focus a slotted
   * beacon-radio-button and update the radio group value from the focused
   * radio-button
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  handleKeydown(t) {
    t.isTrusted && (super.handleKeydown(t), this.radioButtons && !this.disabled && (this.focusFromKey(t, this.radioButtons), this.updateValueFromChecked()));
  }
  postrenderRadioGroupSetup() {
    this.checkOnlyLast(), this.updateValueFromChecked(), this.setFocusableOnEmpty(), this.updateBooleanProps();
  }
  render() {
    var t, e;
    return this.invalid = !((t = this.internals) != null && t.checkValidity()), this.updateBooleanProps(), c` <fieldset name=${this.name}>
      <legend class="label">${this.label}</legend>
      ${this.hint ? c`<p class="hint" id="hint">${this.hint}</p>` : u}
      ${this.invalid ? v`<${this.getScopedTag("beacon-error")} message="${(e = this.internals) == null ? void 0 : e.validationMessage}" id="error"></${this.getScopedTag(
      "beacon-error"
    )}>` : u}
      <div class="radio-buttons">
        <slot
          @beacon-event-click=${this.handleRadioGroupClick}
          @beacon-event-blur=${this.handleBlur}
          @beacon-event-input=${this.handleRadioGroupInput}
          @beacon-event-focus=${this.handleRadioGroupFocus}
          @beacon-event-change=${this.handleRadioGroupChange}
          @slotchange=${this.handleSlotChange}
          @keydown=${this.handleKeydown}
          @blur=${this.handleBlur}
        ></slot>
      </div>
    </fieldset>`;
  }
};
r.tagName = p, r.nestedComponents = V;
let n = r;
d([
  g({ reflect: !0 })
], n.prototype, "name", 2);
d([
  x({ selector: "beacon-radio-button" }, !0)
], n.prototype, "radioButtons", 2);
d([
  O
], n.prototype, "postrenderRadioGroupSetup", 1);
export {
  n as BeaconRadioGroup
};
